module.exports = "pegasus/assets/rectangle-twitter.png";